export default function isStr(v) {
  return (typeof v === 'string')
}
